import styled, { css } from 'styled-components';
import Icon from '@gotamedia/fluffy/Icon';
import FluffyButton from '@gotamedia/fluffy/Button';
import { themeHelpers } from '@gotamedia/fluffy/theme';
import FluffyList from '@gotamedia/fluffy/List';
const Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-a8kx1q-0"
})(["flex:1;display:flex;flex-direction:column;"]);
const Title = styled.h1.withConfig({
  displayName: "style__Title",
  componentId: "sc-a8kx1q-1"
})(["font-size:35px;font-weight:700;color:", ";text-align:center;margin:30px 0;"], ({
  theme
}) => theme.colors.brand);
const StyledIcon = styled(Icon).withConfig({
  displayName: "style__StyledIcon",
  componentId: "sc-a8kx1q-2"
})(["margin-right:8px;"]);
const Text = styled.span.withConfig({
  displayName: "style__Text",
  componentId: "sc-a8kx1q-3"
})(["font-size:20px;font-weight:400;color:", ";text-align:center;margin:30px 0;display:flex;justify-content:center;"], ({
  theme
}) => theme.colors.grey[0]);
const Info = styled.span.withConfig({
  displayName: "style__Info",
  componentId: "sc-a8kx1q-4"
})(["font-size:16px;font-weight:400;color:", ";text-align:center;margin:15px 0;display:flex;justify-content:center;"], ({
  theme
}) => theme.colors.grey[0]);
const Content = styled.div.withConfig({
  displayName: "style__Content",
  componentId: "sc-a8kx1q-5"
})(["display:flex;height:100%;min-height:100%;flex-direction:column;background-color:", ";padding-bottom:32px;"], ({
  theme
}) => theme.colors.grey[5]);
const CardContent = styled.div.withConfig({
  displayName: "style__CardContent",
  componentId: "sc-a8kx1q-6"
})(["display:flex;flex-wrap:wrap;grid-gap:20px;", ""], themeHelpers.isSmallDevice(css(["grid-gap:10px;"])));
const FilterContainer = styled.div.withConfig({
  displayName: "style__FilterContainer",
  componentId: "sc-a8kx1q-7"
})(["display:flex;flex-direction:row;"]);
const SearchBarContainer = styled.div.withConfig({
  displayName: "style__SearchBarContainer",
  componentId: "sc-a8kx1q-8"
})(["display:flex;flex-grow:1;flex-direction:row;"]);
const DatePickerContainer = styled.div.withConfig({
  displayName: "style__DatePickerContainer",
  componentId: "sc-a8kx1q-9"
})(["display:flex;flex-direction:row;"]);
const InfoContainer = styled.div.withConfig({
  displayName: "style__InfoContainer",
  componentId: "sc-a8kx1q-10"
})(["display:flex;flex-direction:column;"]);
const Container = styled.div.withConfig({
  displayName: "style__Container",
  componentId: "sc-a8kx1q-11"
})(["max-width:1320px;width:90%;margin:0 auto;", ""], themeHelpers.isSmallDevice(css(["width:95%;"])));
const DateStamp = styled.h2.withConfig({
  displayName: "style__DateStamp",
  componentId: "sc-a8kx1q-12"
})(["color:", ";font-family:'Sanomat Sans';font-style:normal;font-weight:400;font-size:20px;line-height:24px;;margin-left:5px;padding-top:32px;margin-bottom:12px;"], ({
  theme
}) => theme.colors.grey[2]);
const CardsWrapper = styled(FluffyList).withConfig({
  displayName: "style__CardsWrapper",
  componentId: "sc-a8kx1q-13"
})(["width:100%;display:flex;flex-direction:column;"]);
const LoadMoreButton = styled(FluffyButton).withConfig({
  displayName: "style__LoadMoreButton",
  componentId: "sc-a8kx1q-14"
})(["margin:30px auto 0 auto;"]);
const PaginationWrapper = styled.div.withConfig({
  displayName: "style__PaginationWrapper",
  componentId: "sc-a8kx1q-15"
})(["margin:20px auto;"]);
export { InfoContainer, FilterContainer, SearchBarContainer, DatePickerContainer, Info, DateStamp, Wrapper, CardContent, Title, Text, Content, CardsWrapper, LoadMoreButton, PaginationWrapper, Container, StyledIcon };